import React from "react";
import css from './BooksList.module.scss';
import PropTypes from "prop-types";
import SingleBookTile from "../../../commons/SingleBookTile";

function BooksList({ books }) {
  // Przesuwamy book.id === 69 na koniec
  const sortedBooks = [...books].sort((a, b) => {
    if (a.id === 69) return 1;  
    if (b.id === 69) return -1; 
    return 0; 
  });

  return (
    <>
      <div className={css.BooksList}>
        <div className={css.grid}>
          { sortedBooks.map((book, bookIdx) => (
              <SingleBookTile key={book.id} book={book} bookIdx={bookIdx}/>
            ))
          }
        </div>
      </div>
      <div className={css.frills} />
    </>
  );
}


BooksList.propTypes = {
  books: PropTypes.arrayOf(PropTypes.shape({
    '@id': PropTypes.string.isRequired,
    '@type': PropTypes.string.isRequired,
    id: PropTypes.number.isRequired
  }))
}

export default BooksList;